import { Link } from "react-router-dom";

export default function ImageCard({
    name,
    image = null,
    effect,
    description = null,
    colorClass,
    publicClass,
    color = null,
    click,
    width = 'col-md-4 col-xl-2 col-6',
    isComingSoon,
}) {
    return (
        <div className={`${width} text-center cursor-pointer imageCard position-relative`}>
            {/* برچسب را آوردیم بیرون از کارت و به تگ والد position-relative دادیم */}
            {isComingSoon ? (
                <span
                    className="badge shadow-sm"
                    style={{
                        position: 'absolute',
                        top: '-8px',
                        left: '13px',
                        backgroundColor: '#f00606',
                        color: 'rgb(247, 243, 243)',
                        border: '1px solid #04090e',
                        zIndex: 10,
                        fontSize: '0.75rem',
                        padding: '4px 8px',
                        borderRadius: '6px'
                    }}
                >
                   به زودی
                </span>
            ) : null}

            {/* حالا کارت می‌تواند overflow-hidden داشته باشد تا گوشه‌هایش کاملاً گرد بمانند */}
            <div className={`mb-2 card overflow-hidden ${colorClass} text-white position-relative`} onClick={click}>
                <div
                    className={color ? `card-header ${publicClass}` : `card-header ${colorClass} ${publicClass}`}
                    style={{ backgroundColor: `${color}` }}
                >
                    {image != null ? (
                        <img src={image} alt="avatar" className={`img-homepage ${effect}`} />
                    ) : null}

                    <span className={'text-black'}>{name}</span>

                    {description != null ? (
                        <>
                            <br />
                            <span>{description}</span>
                        </>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
